import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/unauth/get_stations',
};

export const getStationsRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
